import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSamspay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		id: "Type=Samsung Pay",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Vector",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "samsung_pay",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Group",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Vector_2",
						d: "M16.328 8.54045C16.8437 6.04383 18.4302 4.6533 20.905 4.23323C22.7345 3.92277 24.5646 3.91884 26.391 4.24195C28.9391 4.69272 30.471 6.16435 30.959 8.6987C31.336 10.6573 31.3419 12.6369 30.9531 14.5936C30.4314 17.073 28.8039 18.6034 26.3382 19.0219C24.5088 19.3323 22.6787 19.3363 20.8523 19.0132C18.3041 18.5624 16.7655 17.0173 16.2775 14.483C15.8812 12.5114 15.9194 10.5194 16.328 8.54041V8.54045Z",
						fill: "#3056D3"
					})
				}), /* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M23.8978 9.74393C24.8798 9.74393 25.6758 10.5434 25.6758 11.5295C25.6758 11.6093 25.6599 13.2429 25.6599 13.2429H24.999V11.5791C24.999 11.5457 24.9973 11.5126 24.9944 11.48V11.4787H24.9943C24.9438 10.9238 24.4794 10.4891 23.9137 10.4891C23.3143 10.4891 22.8284 10.9772 22.8284 11.5791C22.8284 12.1811 23.3162 12.5833 23.9156 12.5833H24.1412L24.1397 13.2346C24.0573 13.236 23.984 13.2335 23.8978 13.2317C22.9161 13.2108 22.1198 12.5157 22.1198 11.5295C22.1198 10.5434 22.9158 9.74393 23.8978 9.74393ZM20.4494 9.85118C21.3311 9.9453 21.9343 10.6069 21.9343 11.5295C21.9343 12.5156 21.2448 13.2108 20.2631 13.2316C20.1769 13.2334 19.9967 13.236 19.9143 13.2346L19.9128 12.5832H20.2149C20.773 12.5832 21.2302 12.1287 21.2256 11.5682C21.2209 10.9927 20.8469 10.7065 20.6198 10.5855C20.5271 10.5362 20.4235 10.5115 20.3186 10.5115H19.1426V14.2094H18.4851V10.6335C18.4851 10.2015 18.8339 9.85128 19.264 9.85128H20.4494L20.4494 9.85118ZM28.6691 9.95853H29.3447L27.2419 14.3226H26.5663L28.6691 9.95853H28.6691ZM27.2644 11.6658L26.9267 12.3667L25.7648 9.95846H26.4403L27.2644 11.6658Z",
					fill: "white"
				})]
			})
		})
	}) })
});
export default SvgSamspay;
